export default __webpack_public_path__ + "static/media/TT_Norms_Pro_Bold.8ec81f2a.ttf";